import { useState } from 'react';

// material-ui
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import Box from '@mui/material/Box';
// import clipboardCopy from 'clipboard-copy';
import clipboardCopy from 'copy-to-clipboard';

// assets
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const CopyToClipboardWithMUI = ({ textToCopy = '', htmlToCopy = '', sx, size, iconButtonSx, showSnackbar = true }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyClick = async () => {
    try {
      const htmlContent = htmlToCopy;
      const plainText = textToCopy;

      // Use the standard Clipboard API to provide both formats
      // This allows the destination to choose 'Rich Text' if it supports it
      const blobHtml = new Blob([htmlContent], { type: 'text/html' });
      const blobText = new Blob([plainText], { type: 'text/plain' });

      const data = [
        new ClipboardItem({
          'text/html': blobHtml,
          'text/plain': blobText
        })
      ];

      await navigator.clipboard.write(data);
      setCopied(true);
    } catch (error) {
      console.error('Error copying to clipboard:', error);
      // Fallback to plain text if ClipboardItem fails
      clipboardCopy(textToCopy);
    }
  };

  const handleCloseSnackbar = () => {
    setCopied(false);
  };

  return (
    <Box sx={sx}>
      {textToCopy && (
        <IconButton onClick={handleCopyClick} size={size} sx={iconButtonSx}>
          <ContentCopyIcon fontSize="inherit" />
        </IconButton>
      )}
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={copied && showSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message="Copied to clipboard!"
      />
    </Box>
  );
};

export default CopyToClipboardWithMUI;
